export default function TextField(theme) {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          // color: theme.palette.text.dark,
          '& input': {
            // color: theme.palette.text.dark,
            '&:disabled': {
              borderColor: theme.palette.grey[400],
              backgroundColor: theme.palette.grey[200]
            }
          },
          '& input::placeholder': {
            color: '#8c8c8c', // Custom placeholder color
            opacity: 1 // Ensure the placeholder is fully visible
          },
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: theme.palette.primary.light // Hover border color
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.light, // Focused border color (solid)
              borderWidth: '2px' // Ensure it has a solid look
            }
          },
          '& .MuiSelect-icon': {
            color: theme.palette.grey[400] // Light gray dropdown icon color
          },
          '& .MuiInputBase-root': {
            color: theme.palette.grey[500] // Input text color
          },
          '& .MuiInputLabel-root': {
            backgroundColor: '#FFF', // Set label background to transparent
            color: theme.palette.text.dark, // Set label text color to theme.palette.text.dark,
            background: '#FFF'
          }
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.common.white, // Dropdown menu background color
          color: theme.palette.common.black // Dropdown menu text color
        }
      }
    }
  };
}
